import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function Countdown({ target, enabled }) {
  const [time, setTime] = useState({ d: 0, h: 0, m: 0, s: 0 });
  const [isLive, setIsLive] = useState(false);

  useEffect(() => {
    if (!enabled || !target) return;
    const tick = () => {
      const diff = new Date(target).getTime() - Date.now();
      if (diff <= 0) {
        setIsLive(true);
        setTime({ d: 0, h: 0, m: 0, s: 0 });
        return;
      }
      const d = Math.floor(diff / (1000 * 60 * 60 * 24));
      const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const m = Math.floor((diff / (1000 * 60)) % 60);
      const s = Math.floor((diff / 1000) % 60);
      setTime({ d, h, m, s });
    };
    tick();
    const int = setInterval(tick, 1000);
    return () => clearInterval(int);
  }, [target, enabled]);

  if (!enabled) return null;

  if (isLive) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="inline-flex items-center gap-3 px-6 py-3 rounded-full border border-fp-cyan/50 bg-fp-cyan/10"
        data-testid="countdown-live"
      >
        <span className="w-2 h-2 rounded-full bg-fp-cyan animate-pulse" />
        <span className="text-fp-cyan font-heading font-bold tracking-[0.3em] text-sm uppercase">
          Torneo in corso
        </span>
      </motion.div>
    );
  }

  const Block = ({ val, label }) => (
    <div className="flex flex-col items-center" data-testid={`countdown-${label.toLowerCase()}`}>
      <div className="relative min-w-[70px] md:min-w-[100px] aspect-square rounded-xl md:rounded-2xl bg-fp-surface border border-white/10 tracing-border flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 shimmer opacity-30" />
        <span className="relative text-3xl md:text-5xl font-heading font-black silver-gradient">
          {String(val).padStart(2, "0")}
        </span>
      </div>
      <span className="mt-2 text-[10px] md:text-xs tracking-[0.3em] uppercase text-fp-cyan/80 font-heading font-semibold">
        {label}
      </span>
    </div>
  );

  return (
    <div className="flex items-center gap-3 md:gap-5" data-testid="countdown-timer">
      <Block val={time.d} label="Giorni" />
      <span className="text-fp-cyan/60 text-3xl font-bold">:</span>
      <Block val={time.h} label="Ore" />
      <span className="text-fp-cyan/60 text-3xl font-bold">:</span>
      <Block val={time.m} label="Minuti" />
      <span className="text-fp-cyan/60 text-3xl font-bold">:</span>
      <Block val={time.s} label="Secondi" />
    </div>
  );
}
